module.exports = __webpack_public_path__ + "static/Muli-Bold-c841541935dbb22d565ec7f706fed104.woff";